/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./friends.vue?vue&type=template&id=082113f5&scoped=true"
import script from "./friends.vue?vue&type=script&lang=js"
export * from "./friends.vue?vue&type=script&lang=js"
import style0 from "./friends.vue?vue&type=style&index=0&id=082113f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082113f5",
  null
  
)

export default component.exports